<template>
  <div :class="[tabDataContainsIOPropsAndBleSensors ? 'imei-component-container' : '']">
    <v-tabs @change="tabChanged">
      <v-tab class="font-weight-bold">Info</v-tab>
      <v-tab class="font-weight-bold">I/O &amp; Lokacija</v-tab>
      <v-tab
        class="font-weight-bold"
        v-if="tabData.probe"
        >{{ $t("probe") }}</v-tab
      >
      <v-tab class="font-weight-bold" v-if="tabData.can">CAN</v-tab>
      <v-tab class="font-weight-bold" v-if="tabData.tachographData">{{ $t("tachograph") }}</v-tab>
    </v-tabs>

    <component 
      v-if="loadTabs"
      v-bind:is="component"
      :tabData="tabData"
      
    ></component>
  </div>
</template>

<script>
export default {
  name: 'ImeiComponent',
  components: {
    ImeiInfoComponent: () => import('./ImeiInfoComponent'),
    ImeiProbeComponent: () => import('./ImeiProbeComponent'),
    ImeiIoComponent: () => import('./ImeiIoComponent'),
    ImeiCanComponent: () => import('./ImeiCanComponent'),
    ImeiPoiComponent: () => import('./ImeiPoiComponent'),
    ImeiTachographComponent: () => import('./ImeiTachographComponent')
  },
  props: {
    singleImei: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      component: 'ImeiInfoComponent',
      loadTabs: false,
      tabData: {},
      tabDataContainsIOPropsAndBleSensors: false,
    }
  },
  mounted() {
    this.tabData = this.singleImei
    this.loadTabs = true

    if (this.tabData.ioProperties.length && this.tabData.bleSensors.length) {
      this.tabDataContainsIOPropsAndBleSensors = true
    }
  },
  methods: {
    tabChanged(tabIndex) {
      console.log("Tab index: ", tabIndex)
      switch (tabIndex) {
        case 0:
          this.component = 'ImeiInfoComponent'
          break
        case 1:
          this.component = 'ImeiIoComponent'
          break
        case 2:
          if (this.tabData.probe) {
            this.component = 'ImeiProbeComponent'
          } else if (this.tabData.can) {
            this.component = 'ImeiCanComponent'
          } else if (this.tabData.tachographData) {
            this.component = 'ImeiTachographComponent'
          } 
          break
        case 3: 
          if (this.tabData.can && this.tabData.tachographData) {
            this.component = 'ImeiTachographComponent'
          } else if (this.tabData.can) {
            this.component = 'ImeiCanComponent'
          } else if (this.tabData.tachographData) {
            this.component = 'ImeiTachographComponent'
          }
          break

        default:
          this.component = 'ImeiCanComponent'
      }
    }
  },
  watch: {
    singleImei: {
      handler() {
        this.tabData = this.singleImei
      }
    }
  }
}
</script>
<style scoped>
.v-tab,
.v-btn {
  font-size: 15px !important;
}
.leaflet-popup-content-wrapper {
  width: 350px;
}

.leaflet-popup-content {
  height: 250px;
}

.imei-component-container {
  height: 300px !important;
}
</style>
